import { useState } from "react";
import { PageHeading } from "../../components/common/pageHeading/PageHeading";
import productImgPlaceholder from "../../assests/images/placeholder_image.webp";
import styles from "./productDetails.module.css";
import { Button, Card, Col, Container, Image, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  useGetProductQuery,
  useDeleteProductMutation,
} from "../../features/api/products/productsApi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons";
import dateFormatter from "../../utils/dateFormatter";
import AlertDismissible from "../../components/common/alertDismissible/AlertDismissible";
import { Loader } from "../../components/common/loader/Loader";
import { SuccessDelete } from "../../components/common/successDelete/SuccessDelete";
import { useIsAdmin } from "../../customHooks/roleChecker/useIsAdmin";
import { useIsSuperAdmin } from "../../customHooks/roleChecker/useIsSuperAdmin";
import { useIsManager } from "../../customHooks/roleChecker/useIsManager";
import useIsMobile from "../../customHooks/useIsMobile";
import { useIsSeniorSalesExecutive } from "../../customHooks/roleChecker/useIsSeniorSalesExecutive";
import { useIsSalesExecutive } from "../../customHooks/roleChecker/useIsSalesExecutive";
export const ProductDetails = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const isAdmin = useIsAdmin();
  const isManager = useIsManager();
  const isSuperAdmin = useIsSuperAdmin();
  const isSeniorSalesExecutive = useIsSeniorSalesExecutive();
  const isSalesExecutive = useIsSalesExecutive();
  const { productId } = useParams();
  const [showAlert, setShowAlert] = useState(false);
  const {
    data: productDetail,
    isLoading,
    isError,
  } = useGetProductQuery(productId);

  const [
    deleteProduct,
    {
      isLoading: isDeleting,
      isSuccess: isSuccessOnDelete,
      isError: isErrOnDelete,
    },
  ] = useDeleteProductMutation();
  const handleDelete = (productId) => {
    setShowAlert(true);
  };
  let content = null;
  const handleConfirm = async (confirmed) => {
    setShowAlert(confirmed);
    if (confirmed) {
      await deleteProduct(productId).unwrap();
      setTimeout(() => {
        navigate("/inventory");
      }, 3000);
    }
    return;
  };

  if (isLoading || isDeleting) {
    content = (
      <div className="mb-5">
        <PageHeading title={"Product details"} />
        <Loader />
      </div>
    );
  }
  if (isSuccessOnDelete) {
    content = (
      <div className="mb-5">
        <PageHeading title={"Product details"} />
        <SuccessDelete />
      </div>
    );
  }
  if (isErrOnDelete) {
    content = (
      <div className="mb-5">
        <PageHeading title={"Product details"} />
        <p>Server error</p>
      </div>
    );
  }
  if (productDetail && !isSuccessOnDelete && !isDeleting) {
    content = (
      <div className="mb-5">
        <AlertDismissible
          title="Warning!"
          msg="Are you sure you want to proceed?"
          type="warning"
          showAlert={showAlert}
          onConfirm={handleConfirm}
        />
        <PageHeading title={"Product details"} />
        <Container className={`${styles.productContainer} my-5`}>
          <Button
            variant="outline-light"
            onClick={() => navigate("/inventory")}
            className={`${styles.btnProductList} m-4 py-1 p-md-2`}
          >
            <FontAwesomeIcon icon={faList} size={isMobile ? "m" : "xl"} />
          </Button>{" "}
          <h2 className={`${styles.productName} shadow-sm`}>
            {productDetail?.name}
          </h2>
          <hr />
          <Row>
            <Col lg={3} md={6} xs={6} className="mt-1">
              <Card border="info">
                <Card.Header>In Stock</Card.Header>
                <Card.Body>
                  <Card.Title className={styles.cardTitle}>
                    {productDetail?.unit}
                  </Card.Title>
                  <Card.Subtitle className="mb-1 text-muted">
                    On :{" "}
                    {dateFormatter(
                      productDetail?.productLogResponses[
                        productDetail.productLogResponses.length - 1
                      ]?.updatedAt,
                    )}
                  </Card.Subtitle>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6} xs={6} className="mt-1">
              <Card border="info">
                <Card.Header>Updated</Card.Header>
                <Card.Body>
                  <Card.Title className={styles.cardTitle}>
                    By :{" "}
                    {
                      productDetail?.productLogResponses[
                        productDetail.productLogResponses.length - 1
                      ]?.updatedBy
                    }
                  </Card.Title>
                  <Card.Subtitle className="mb-1 text-muted">
                    At :{" "}
                    {dateFormatter(
                      productDetail?.productLogResponses[
                        productDetail.productLogResponses.length - 1
                      ]?.updatedAt,
                    )}
                  </Card.Subtitle>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6} xs={6} className="mt-1">
              <Card border="info">
                <Card.Header>Pricing</Card.Header>
                <Card.Body>
                  <Card.Title className={styles.cardTitle}>
                    Selling : {productDetail?.sellingPrice}€
                  </Card.Title>
                  {!isSalesExecutive && (
                    <Card.Subtitle className="mb-1 text-muted">
                      Intake : {productDetail?.intakePrice}€
                    </Card.Subtitle>
                  )}
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6} xs={6} className="mt-1">
              <Card border="info">
                <Card.Header>Description</Card.Header>
                <Card.Body>
                  <Card.Title className={styles.cardTitle}>
                    SKU : {productDetail?.sku}
                  </Card.Title>
                  <Card.Subtitle className="mb-1 text-muted">
                    Created At : {dateFormatter(productDetail?.createdAt)}
                  </Card.Subtitle>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="my-2">
            <Col className="mt-1">
              <Card border="info">
                <Card.Header>Detail description</Card.Header>
                <Row>
                  <Col lg={6} xs={12} md={6} className="text-center my-3">
                    <Image
                      className={styles.productImage}
                      fluid
                      src={
                        productDetail?.image
                          ? `data:image/webp;base64,${productDetail.image}`
                          : productImgPlaceholder
                      }
                    />
                  </Col>
                  <Col lg={6} xs={12} md={6}>
                    <Card.Body>
                      <Card.Text>
                        Manufacturer : {productDetail?.manufacturer}
                      </Card.Text>
                      <Card.Text>Origin : {productDetail?.origin}</Card.Text>
                      <Card.Text>
                        Dimension : {productDetail?.dimension}
                      </Card.Text>
                      <Card.Text>Weight : {productDetail?.weight}</Card.Text>
                      <Card.Text>Size : {productDetail?.size}</Card.Text>
                      <Card.Text>
                        Category : {productDetail?.category}
                      </Card.Text>
                      {(isSuperAdmin ||
                        isAdmin ||
                        isManager ||
                        isSeniorSalesExecutive) && (
                        <div>
                          <hr />
                          <Link to={`/edit-product/${productDetail?.id}`}>
                            <Button variant="warning" className="px-5 me-2">
                              Edit
                            </Button>
                          </Link>
                          {!isSeniorSalesExecutive && (
                            <Button
                              variant="danger"
                              className="px-5"
                              onClick={handleDelete}
                            >
                              Delete
                            </Button>
                          )}
                        </div>
                      )}
                    </Card.Body>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return content;
};
